import get from 'lodash/get';
import isBoolean from 'lodash/isBoolean';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import ClearIcon from '@mui/icons-material/Clear';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {useUpdateSessionMutation} from '../../redux/services/sessionApi';
import CustomCheckbox from '../common/CustomCheckbox';
import CustomTextField from '../common/CustomTextField';

const handleSubmit = ({
  updateSession,
  sessionId,
  setDialogIsOpen,
}) => async formData => {
  let body = {is_canceled: true};
  if (formData.isNoShow) body.is_no_show = true;
  if (formData.cancelNote) body.cancel_note = formData.cancelNote;
  if (isBoolean(formData.sendNotification)) {
    body.send_notification = formData.sendNotification;
  }
  const req = await updateSession({id: sessionId, body});
  if (req.data && !req.error) {
    setDialogIsOpen(false);
  }
}

const CancelSessionDialog = props => {
  const {session, isPatient} = props;
  const [cancelNote, setCancelNote] = useState('');
  const [isNoShow, setIsNoShow] = useState(false);
  const [dialogIsOpen, setDialogIsOpen] = useState();
  const [sendNotification, setSendNotification] = useState(true);
  const [updateSession, response] = useUpdateSessionMutation();
  const navigate = useNavigate();
  const onSubmit = handleSubmit({
    updateSession,
    sessionId: get(session, 'id'),
    setDialogIsOpen,
  });
  const formData = {cancelNote, isNoShow, sendNotification};
  return (
    <>
      <Button
        size={props.size}
        variant={props.variant}
        disabled={
          session.is_canceled
          || session.is_completed
          || (response.data && !response.error)
        }
        onClick={() => setDialogIsOpen(true)}
      >
        <ClearIcon />
        {' '}
        Cancel Session
      </Button>
      <Dialog
       open={dialogIsOpen}
       onClose={() => setDialogIsOpen(false)}
       fullWidth={true}
       maxWidth='sm'
       aria-labelledby="alert-dialog-title"
       aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{padding: '0'}}>
          <Typography variant='h1' padding={2}>
            Cancel Session
          </Typography>
          <Divider/>
          <Stack spacing={1} padding={2}>
            {get(response, 'error')
              ? <Alert severity='error'>
                There was an error processing your request. Please try again later.
              </Alert>
              : null
            }
            <CustomTextField
              label='Note'
              type='textarea'
              multiline
              rows={3}
              placeholder='Optional note'
              onChange={e => setCancelNote(e.target.value)}
            />
            {isPatient ? null : <CustomCheckbox
              label='No show'
              onChange={e => setIsNoShow(e.target.value)}
            />}
            {isPatient ? null : <CustomCheckbox
              label='Send email and cancel invitation'
              defaultValue={true}
              onChange={e => setSendNotification(e.target.value)}
            />}
            {
              isPatient &&
              <Typography variant='body1'>
                  A quick reminder: We have a 24-hour cancellation policy, if you are cancelling the session 
                  within 24 hours of your appointment, you may be charged in full. We are happy to accomodate 
                  a virtual visit in the case of illness or travel.
              </Typography>
            }
          </Stack>
        </DialogContent>
        <DialogActions>
          <Stack paddingBottom={1} className='w-100' spacing={2} direction="row" useFlexGap flexWrap='wrap' justifyContent='center' >
            <Button variant='primaryOutline' onClick={() => setDialogIsOpen(false)}>
              Close
            </Button>
            <Button
              variant='primaryOutline'
              color='error'
              onClick={() => onSubmit(formData)}
            >
              Cancel Session
            </Button>
            <Button
              variant='primaryGradient'
              color='error'
              onClick={() => {
                onSubmit(formData);
                navigate(
                  isPatient
                  ? `/clients/appointments/new/${session.provider.id}`
                  : `/providers/appointments/patients/${session.patient.id}`
                );
              }}
            >
              Cancel & Reschedule
            </Button>
            {/* <Button
              variant='primaryGradient'
              onClick={() => {
                onSubmit(formData, {redirect: '//'});
              }}
            >
              Cancel and Reschedule
            </Button> */}
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CancelSessionDialog;
